export const appStart = () => ({
  type: 'APP_START',
});
